import script from "./customHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./customHeader.vue?vue&type=script&setup=true&lang=ts"

import "./customHeader.vue?vue&type=style&index=0&id=06898666&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06898666"]])

export default __exports__